import React from 'react';
import { ImageSkeleton, LineSkeleton } from '../../Skeletons/skeletonTemplates';

export default function WhatYouLearn(props) {
    if (props.data && !props.data.content)
        return (<div />)
    return (
        <section className = "learnings">
            <div className="container col-md-9">
                <h2 className ="font-weight-bold d-block d-sm-none mb-4">What you will learn</h2>
                <div className = "row">
                    <div className = "col-12 order-sm-12 col-sm-4 custom-height my-auto">
                        {!props.data ? 
                                <ImageSkeleton classes = "icon-size"/>
                            :
                                <>
                                    <img className = "img-fluid icon-size d-block d-sm-none mx-auto course-landing-image" src = {props.data.learningsIcon} alt = "avtar"></img>
                                    <img className = "img-fluid icon-size d-none d-sm-block course-landing-image" src = {props.data.learningsIcon} alt = "avtar"></img>
                                </>
                        }
                    </div>
                    <div className = "col-12 order-sm-1 col-md-8 learnings-text my-auto">
                        <h2 className ="font-weight-bold d-none d-sm-block text-left pl-3 mb-4">What you will learn</h2>
                        {!props.data 
                            ?
                                LineSkeleton(6) 
                            :
                                <div className = "text-muted text-left urw-din text-lg learningsText" dangerouslySetInnerHTML={{ __html: props.data.content }} />
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}